@if (isUserAuthenticated()) {
  <div class="card flex">
    <p-tieredmenu #menu [model]="items" [popup]="true" />
    <p-button (click)="menu.toggle($event)" icon="pi pi-ellipsis-v" />
  </div>
}
